import { render, staticRenderFns } from "./qxtbxiangqingLess.vue?vue&type=template&id=59b87e06&scoped=true"
import script from "./qxtbxiangqingLess.vue?vue&type=script&lang=js"
export * from "./qxtbxiangqingLess.vue?vue&type=script&lang=js"
import style0 from "./qxtbxiangqingLess.vue?vue&type=style&index=0&id=59b87e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b87e06",
  null
  
)

export default component.exports